<template>
  <div style="display: flex; justify-content: center;">
    <div class="sign-field">
      <img v-if="image" :src="image" style="border: 0; min-height:80px;" @click="handleClickImage"/>
      <div v-else @click.stop="handleClick" style="width:100%; height: 100%; min-height:80px; min-width: 120px; display: flex; justify-content: center; align-items: center; color: #3c3c3c">클릭하여<br>서명하기</div>
      <popup-sign-field v-model="showPopup" :image="image" :readonly="readonly" @save="handleSave" @delete="handleDelete"/>

    </div>
  </div>
</template>

<script>
import PopupSignField from '@/popup/PopupSignField'
export default {
  name: 'SignField',
  components: {PopupSignField},
  props: {
    value: String,
    readonly: Boolean
  },
  data () {
    return {
      image: this.value,
      showPopup: false
    }
  },
  watch: {
    value (value) {
      this.image = value
    },
    image (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    handleSave (value) {
      this.image = value
    },
    handleDelete () {
      if (confirm("삭제하시겠습니까?")) {
        this.image = ''
      }
    },
    handleClick () {
      this.showPopup = true
    },
    handleClickImage () {
      this.showPopup = true
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-field {
  display: grid;

  width: 100%;
  height: 100%;

  min-width: 120px;
  max-width:250px;
  min-height: 80px;

  border: solid 1px #cdcdcd;
  border-radius: 6px;


  img {
    width: 100%;
    height: 100%;

    display: inline-block;
    content: "";
    border-radius: 6px;
  }
}
</style>
